import {createApp, defineAsyncComponent} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'
import {sentryInit} from 'shared/utils/sentryWithVueAndNotification'
import {api} from 'shared/plugins/api'
import {useModals} from 'shared/composables/useModals'
import {useNotifyStore} from 'shared/stores/notify'
import {apolloProvider} from 'shared/apollo'
import {resumeSdkRecording} from 'shared/utils/birdSdk'
import auth from 'shared/plugins/auth'

import 'inter-ui/inter.css'
import 'shared/styles/tailwind.css'
import 'shared/styles/global.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import {registerBaseComponents} from 'shared/baseComponents'

// Custom directives
import clickOutsideDirective from 'shared/directives/clickOutside'
import resizeDirective from 'shared/directives/resize'

// Pinia Stores
import {useStore} from 'shared/stores/store'
import {useWorkspaceSubscriptionStore} from 'shared/stores/workspaceSubscription'
import {useRouterHelpers} from 'shared/composables/useRouterHelpers'
import {usePaddleStore} from 'shared/stores/paddle'
import {useSessionLayoutStore} from 'shared/stores/sessionLayout'

const app = createApp(App)
const pinia = createPinia()
sentryInit(app)

app.use(auth)
app.use(apolloProvider)
app.use(router)
app.use(pinia)

const routerHelpers = useRouterHelpers(router)

app.config.globalProperties.$api = api
app.config.globalProperties.$store = useStore()
app.config.globalProperties.$workspaceSubscription = useWorkspaceSubscriptionStore()
app.config.globalProperties.$routerHelpers = routerHelpers
app.config.globalProperties.$paddle = usePaddleStore()
app.config.globalProperties.$sessionLayout = useSessionLayoutStore()
app.config.globalProperties.$modals = useModals(routerHelpers)
app.config.globalProperties.$notify = useNotifyStore()
app.config.globalProperties.$env = import.meta.env

app.directive('click-outside', clickOutsideDirective)
app.directive('resize', resizeDirective)

registerBaseComponents(app)

app.component(
	'ConsoleEventArg',
	defineAsyncComponent(() => import('shared/components/ConsoleEventArg.vue'))
)

router.isReady().then(() => app.mount('#app'))

if (import.meta.env.DEV) {
	window.app = app
}

resumeSdkRecording()
